<template>
 <div>
     <p>Loading... <a href="ts3server://labyhelp.de">Dont work? click here</a></p>
 </div>
</template>

<script>
    export default {
        name: "Teamspeak"
    }

    window.open("ts3server://labyhelp.de");

</script>

<style scoped>

</style>